define([
    "./nlgFilterFieldInputModule",
    "./nlgFilterFieldInputDirective",
], function () {
});
